import { Glyph } from '../common/Glyph';

import { useI18n } from '../../hooks/useI18nFormatters';
import { useCapabilityValue } from '../../store/devices/useCapabilityValue';

import { glyph } from '../../theme/glyph';
import { theme } from '../../theme/theme';
import styles from './IndicatorLock.module.css';

export function IndicatorLock(props) {
  const { i18n } = useI18n();
  const [value, , capabilityObj] = useCapabilityValue({
    deviceId: props.device.id,
    capabilityId: 'locked',
  });

  if (capabilityObj == null) {
    return null;
  }

  const glyphSource = value === true ? glyph.capability.lockClosed : glyph.capability.lockOpen;
  const lockLabel =
    value === true
      ? i18n.messageFormatter('device.lock.locked')
      : i18n.messageFormatter('device.lock.unlocked');

  return (
    <div className={styles.root}>
      <Glyph
        className={styles.statusIcon}
        source={glyphSource}
        color={theme.color.yellow}
        size={theme.icon.size_small}
      />
      <div className={styles.statusText}>{lockLabel}</div>
    </div>
  );
}
